import * as React from 'react';
import classNames from 'classnames';
import FieldBase from './FieldBase';
import { IFieldBaseProperties, IFieldValueProperties, IValidationProperties } from './interfaces';
import FieldTypes from './enums/FieldTypes';

interface ITextFieldProperties extends IFieldBaseProperties, IFieldValueProperties, IValidationProperties { }

export class TextField extends React.PureComponent<ITextFieldProperties> {
  constructor(props: ITextFieldProperties) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(event: React.FormEvent<HTMLInputElement>) {
    event.preventDefault();

    if (this.props.onChange !== undefined)
    {
      this.props.onChange({
        id: event.currentTarget.id,
        name: event.currentTarget.name,
        value: event.currentTarget.value
      });
    }
  }

  render() {    
    let inputClasses = classNames({
      "hcs-text__input": true,
      "w-full": true,
      "input-validation-error": this.props.valid === false
    });

    return <FieldBase key={this.props.id + "_field"} {...this.props} type={FieldTypes.TEXT}>
      <input 
        key={this.props.id + "_text"} 
        type="text" 
        className={inputClasses}
        id={this.props.id} 
        name={this.props.id} 
        value={this.props.value || ''}
        onChange={this.onChange}
        maxLength={200}
        disabled={this.props.disabled}
        required={this.props.required} />
        { this.props.valid === false && <span className="hcs-label-text__error-msg">{this.props.message}</span>}
    </FieldBase>;
  }
}

export default TextField;